<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center row pa-5>
            <v-flex xs12 sm10 md6 text-center>
                <div class="mb-5">
                    <h1>ค้นหาพัสดุนอกเวลา</h1>
                </div>
                <div>
                    <v-text-field
                            label="ชื่อ-สกุล,ยูนิต,บ้านเลขที่,โทร,เลขอ้างอิง"
                            outlined
                            @keypress.enter="goto('ot-parcel-list')"
                            v-model="searchText"
                    ></v-text-field>
                </div>
                <div>
                    <v-btn color="#1565C0"
                           block
                           large
                           dark
                           @click="goto('ot-parcel-list')">
                        ค้นหา
                    </v-btn>
                </div>
<!--                <div class="mt-5">-->
<!--                    <v-btn color="#4CAF50"-->
<!--                           block-->
<!--                           large-->
<!--                           dark-->
<!--                           @click="goto('gen-link')">-->
<!--                        สร้าง link สำหรับลูกค้า-->
<!--                    </v-btn>-->
<!--                </div>-->
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from '@/axios';
    import EventBus from '@/EventBus'

    export default {
        name   : "OTParcelEmployee",
        data() {
            return {
                searchText: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'บันทึกรับพัสดุนอกเวลา', back_route: 'main-menu'});

            let localItem = this.getLocalItem();
            delete localItem.itemSelected;
            delete localItem.itemsParcel;
            delete localItem.searchText;
            localStorage.setItem('parcel', JSON.stringify(localItem))
        },
        methods: {
            goto(route_name, params) {
                if (route_name == 'logout') {
                    EventBus.$emit('resetToken')
                    return this.logout()
                } else {
                    if (params) {
                        EventBus.$emit(params.eventbus_call, params.params)
                    }
                    if (route_name == 'ot-parcel-list') {
                        let parcel = this.getLocalItem();
                        parcel.searchText = this.searchText
                        localStorage.setItem('parcel', JSON.stringify(parcel))
                    }
                    return this.$router.push({name: route_name})
                }
            }
        }
    }
</script>

<style scoped>

</style>
